var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgObjectivesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "target-108_1_",
    "data-name": "target-108 (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13969",
    "data-name": "Path 13969",
    d: "M365.875,362.667a3.208,3.208,0,1,0,3.208,3.208A3.248,3.248,0,0,0,365.875,362.667Zm0,4.583a1.375,1.375,0,1,1,1.375-1.375A1.41,1.41,0,0,1,365.875,367.25Z",
    transform: "translate(-354.875 -354.875)",
    fill: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13970",
    "data-name": "Path 13970",
    d: "M21.083,10.083H20.075a9.087,9.087,0,0,0-8.158-8.158V.917a.917.917,0,1,0-1.833,0V1.925a9.005,9.005,0,0,0-8.158,8.158H.917a.917.917,0,1,0,0,1.833H1.925a9.087,9.087,0,0,0,8.158,8.158v1.008a.917.917,0,1,0,1.833,0V20.075a9.087,9.087,0,0,0,8.158-8.158h1.008a.917.917,0,1,0,0-1.833Zm-9.167,8.158v-.825a.917.917,0,1,0-1.833,0v.825a7.3,7.3,0,0,1-6.325-6.325h.825a.917.917,0,0,0,0-1.833H3.758a7.207,7.207,0,0,1,6.325-6.325v.825a.917.917,0,0,0,1.833,0V3.758a7.3,7.3,0,0,1,6.325,6.325h-.825a.917.917,0,1,0,0,1.833h.825a7.207,7.207,0,0,1-6.325,6.325Z",
    fill: ""
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjectivesIcon);
export default __webpack_public_path__ + "static/media/objectives-icon.73d2fc4bfe4e8c0841fadcda411b5f3d.svg";
export { ForwardRef as ReactComponent };